<template>
  <div class="checkout_summary pt-4 ">
    <form action="" @submit.prevent="SendOrderRows" class="">
      <h2 class="pb-3">{{$t('formTitle')}}</h2>
      <p class="text-center">{{$t('formDescription')}}</p>
      <input type="hidden" name="fbclid" class="fbclid" :value="addFBclid()">
      <input type="hidden" name="gclid_field" id="gclid_field" :value="addGclid()">
      <input type="hidden" name="post_url" :value="post_url">
      <div class="form-group">
        <div class="InputHolder form-control">
          <input type="text" class="" :placeholder="$t('firstName')" required @blur="ValidateInput" name="firstName"
                 :value="firstPerson.firstName"
                 @input="commit_firstperson_details('firstName',$event)"
          >
          <i class="icon-checkbox-checked opacity-0"></i>
        </div>
      </div>
      <div class="form-group">
        <div class="InputHolder form-control">
          <input type="text" class="" :placeholder="$t('lastName')" required @blur="ValidateInput" name="lastName"
                 :value="firstPerson.lastName"
                 @input="commit_firstperson_details('lastName',$event)">
          <i class="icon-checkbox-checked opacity-0"></i>
        </div>
        <div class="InputHolder form-control">
          <input type="text" class="" :placeholder="$t('phone')"  required @blur="ValidateInput" name="phone"
                 :value="firstPerson.phone"
                 @input="commit_firstperson_details('phone',$event)">
          <i class="icon-checkbox-checked opacity-0"></i>
        </div>
      </div>
      <div class="form-group flex-wrap  flex-lg-nowrap ">
        <div class="w-100">
          <multiselect :options="optionsTidsplan" :searchable="false" :show-labels="false"
                       label="name"
                       class="tidsPlanMultiselect"
                       :allow-empty="false"
                       v-model="contactTidsPlan"
                       :placeholder="$t('Tidsplan')"></multiselect>
        </div>
        <div class="w-100">
          <multiselect :options="optionsKontaktWay" :searchable="false" :show-labels="false"
                       label="name"
                       class="KontaktWayMultiselect"
                       :allow-empty="false"
                       v-model="contactKontaktWay"
                       :placeholder="$t('contactKontaktWay')"></multiselect>
        </div>
      </div>
      <div class="form-group">
        <div class="InputHolder form-control">
          <input type="text" class=""
                 :placeholder="$t('propertyName')"
                 required @blur="ValidateInput" name="province"
                 @input="commit_contact_details('propertyName',$event)"
                 :value="contact.propertyName">
          <i class="icon-checkbox-checked opacity-0"></i>
        </div>
      </div>
      <div class="form-group">
        <div class="InputHolder form-control">
          <input type="text" class="" required @blur="ValidateInput" name="zipcode"
                 :value="firstPerson.zip"
                 :placeholder="$t('zip')"
                 @input="commit_contact_details('zip',$event)">
          <i class="icon-checkbox-checked opacity-0"></i>
        </div>
        <div class="InputHolder form-control">
          <input type="text" class="" required @blur="ValidateInput" name="city"
                 :value="contact.city"
                 :placeholder="$t('city')"
                 @input="commit_contact_details('city',$event)">
          <i class="icon-checkbox-checked opacity-0"></i>
        </div>
      </div>
      <div class="form-group">
        <div class="InputHolder form-control">
          <input type="email" class=""  :placeholder="$t('email')"  required @blur="ValidateInput" name="email"
                 :value="firstPerson.email"
                 @input="commit_firstperson_details('email',$event)">
          <i class="icon-checkbox-checked opacity-0"></i>
        </div>
      </div>
      <div class="form-group">
        <div class="InputHolder form-control">
          <textarea name="" id="" rows="4" class=""  :placeholder="$t('messageToSeller')"
                    :value="contact.messageToSeller"
                    @input="commit_contact_details('messageToSeller',$event,true)"></textarea>
        </div>
      </div>
      <div class="SubmitBtnHolder">

        <div class="d-flex align-items-center gap-2 justify-content-between flex-wrap">
          <label for="">
            <input type="checkbox" required>
            <span> {{ $t('acceptConditions') }}</span>
          </label>
          <button class="btn NextBtn" type="submit" :disabled="sending">
            {{ $t('sendBtn') }}
            <i class="icon-spinner " v-if="sending" id="ProcessSendingForm"></i>
          </button>
        </div>

      </div>
    </form>
    <div class="alert alert-danger mt-3" v-if="errorMsg">{{ $t('errorMsg') }}</div>
    <div class="alert alert-success mt-3" v-if="successMsg">{{ $t('successMsg') }}</div>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import axios from "axios";

export default {
  name: "Summary",
  components: {Footer},
  data() {
    return {
      sending: false,
      errorMsg: false,
      month:this.$t('month'),
      successMsg: false,
      optionsTidsplan: [
        {key: '1-2', name: `1-2 ${this.$t('month')}`},
        {key: '3-6', name: `3-6 ${this.$t('month')}`},
        {key: '6-12', name: `6-12 ${this.$t('month')}`},
        {key: '12', name:  `12 ${this.$t('months')}`}
      ],
      optionsKontaktWay: [
        {key: 'telefon', name: `${this.$t('telefon')}`},
        {key: 'mail', name: `${this.$t('mail')}`},
        {key: 'both', name: `${this.$t('both')}`}
      ],
      isValid: false,
    }
  },
  computed: {
    prefabThankYouUrl() {
      return window.prefabThankYouUrl !== undefined
          ? window.prefabThankYouUrl
          : 'https://husverket.se/bygg-online/tack-for-din-bokningsforfragan-prefab';
    },
    contactTidsPlan: {
      get() {
        return this.$store.state.order.contact.tidsPlan
      },
      set(n) {
        this.commit_contact_details_select('tidsPlan', n)
      }
    },
    contactKontaktWay: {
      get() {
        return this.$store.state.order.contact.KontaktWay
      },
      set(n) {
        this.commit_contact_details_select('KontaktWay', n)
      }
    },
    post_url() {
      return window.location
    },
    order() {
      return this.$store.state.order
    },
    contact() {
      return this.$store.state.order.contact;
    },
    firstPerson() {
      return this.$store.state.order.contact.persons[0];
    },

    SubCategories() {
      return this.$store.getters.SubCategories
    },

  },
  methods: {
    commit_contact_details_select(type, e, b = false) {

      this.$store.commit('commit_contact_details', {
        type: type,
        val: e,
        b: b
      })
    },
    commit_previous_view() {
      let previousStep = this.SubCategories.length
      this.$store.commit('commit_current_view', this.SubCategories[previousStep - 1].category_nr)
      this.$store.commit('commit_current_category', this.SubCategories[previousStep - 1])
    },
    ValidateInput(e) {
      let val = e.target.value

      if (val.trim().length) {
        e.target.parentElement.classList.add('filled')
      } else {
        e.target.parentElement.classList.remove('filled')
      }
    },
    commit_contact_details(type, e, b = false) {
      this.$store.commit('commit_contact_details', {
        type: type,
        val: e.target.value,
        b: b
      })
    },
    commit_firstperson_details(type, e) {
      this.$store.commit('commit_firstperson_details', {
        type: type,
        val: e.target.value
      })
    },
    SendOrderRows() {
      this.isValid = true;
      let lang = window.myLang !== undefined ? window.myLang : 'swe'

      if (this.order.contact.tidsPlan.name === undefined) {
        document.getElementsByClassName('tidsPlanMultiselect')[0].classList.add('error')
        this.isValid = false;
      } else {
        document.getElementsByClassName('tidsPlanMultiselect')[0].classList.remove('error')
      }
      if (this.order.contact.KontaktWay.name === undefined) {
        document.getElementsByClassName('KontaktWayMultiselect')[0].classList.add('error')
        this.isValid = false;
      } else {
        document.getElementsByClassName('KontaktWayMultiselect')[0].classList.remove('error')
      }

      if (this.isValid) {
        this.successMsg = false
        this.errorMsg = false
        this.sending = true
        let url = window.PrefabApiUrl !== undefined ? window.PrefabApiUrl : process.env.VUE_APP_PUBLIC_API_URL
        axios.post(url + '/save-house-builder', {
          order: this.order,
          lang:lang,
          gclick_id: this.$store.state.gclick_id,
          fbclid: this.$store.state.fbclid
        }).then(res => {
          if (res.data.success) {
            this.sending = false
            this.successMsg = true
            if (window.location.hostname !== 'localhost') {
              dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object
              let items = []
              Array.from(this.$store.state.order.rows).forEach(function (x) {
                items.push({
                  item_id: x.article.article_nr,
                  item_name: x.article.title,
                  affiliation: "PrefabByggonline",
                  coupon: "",
                  discount: x.article.discount,
                  index: x.article.order !== undefined ? x.article.order : '',
                  item_brand: x.article.manufacturer,
                  item_category: x.article.top_head_category !== undefined ? x.article.top_head_category : '',
                  item_category2: x.category.title,
                  item_list_id: x.category.category_nr,
                  item_list_name: x.category.section,
                  item_variant: x.article.telverkare_color !== undefined ? x.article.telverkare_color : '',
                  location_id: x.article.manufaktur_artnr !== undefined ? x.article.manufaktur_artnr : '',
                  price: x.article.out_price_ex_sek * 1.25,
                  quantity: x.article.quantity
                })
              })
              dataLayer.push({
                event: "purchase",
                ecommerce: {
                  currency: "SEK",
                  value: this.$store.getters.totalPrice,
                  tax: this.$store.getters.totalPrice - this.$store.getters.totalPrice * 0.8,
                  transaction_id: res.data.call,
                  items: items
                }
              });
            }

            location.replace(this.prefabThankYouUrl + '?pid=' + res.data.call);
          } else {
            this.sending = false
            this.errorMsg = true
          }

        }).catch(error => {
          this.sending = false
          this.errorMsg = true
        })
      }

    },
    addFBclid() {
      var fbclidParam = this.getParam('fbclid');

      if (fbclidParam) {
        var fbclidRecord = this.getExpiryRecord(fbclidParam);
        localStorage.setItem('fbclid', JSON.stringify(fbclidRecord));
        document.cookie = `fbclid=${fbclidParam}; path=/; max-age=7776000`; // 90 days
      }

      // Retrieve stored fbclid
      var fbclidData = localStorage.getItem('fbclid');

      // Ensure the item exists before parsing
      if (!fbclidData) {
        console.warn("No fbclid found in storage.");
        return null;
      }

      try {
        var parsedFbclid = JSON.parse(fbclidData);
        this.$store.state.fbclid = parsedFbclid.value
        return parsedFbclid?.value || null; // Ensure parsed data has a value
      } catch (error) {
        console.error("Error parsing fbclid from storage:", error);
        return null;
      }
    },
    addGclid() {
      var gclidParam = this.getParam('gclid');
      var gclidRecord = null;

      var gclsrcParam = this.getParam('gclsrc');
      var isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;


      if (gclidParam && isGclsrcValid) {
        gclidRecord = this.getExpiryRecord(gclidParam);
        localStorage.setItem('gclid', JSON.stringify(gclidRecord));
      }

      var gclid = gclidRecord || JSON.parse(localStorage.getItem('gclid'));
      var isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;
      if (isGclidValid) {
        this.$store.state.gclick_id = gclid.value
        return gclid.value
      }
    },
    getParam(p) {
      var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
      return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    },
    getExpiryRecord(value) {
      var expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds

      var expiryDate = new Date().getTime() + expiryPeriod;
      return {
        value: value,
        expiryDate: expiryDate
      };
    },
  },

}
</script>

<style lang="scss">
.icon-spinner {
  display: inline-block;
  animation: anim-rotate 2s infinite linear;
}

@keyframes anim-rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.checkout_summary {


  h2 {
    color: var(--gray-black, var(--things, #000));
    text-align: center;
    font-size: 44px;
    font-style: normal;
    font-weight: 450;
    line-height: 145.5%; /* 64.02px */
    letter-spacing: -0.88px;
    margin: 0;
    @media screen and (max-width: 769px) {
      font-size: 32px;
    }
  }

  ::placeholder {

    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 26px !important;
    color: #A4A4A4;
    font-family: "DM Sans", sans-serif;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .form-group {
      display: flex;
      gap: 16px;
      background-color: white !important;
      border: 0;
      padding: 0;

      &:focus-within {
        box-shadow: unset;
        border: unset;
      }

      .InputHolder {
        width: 100%;
        border: 1px solid var(--gray-06, #E2E2E2);
        display: flex;
        align-items: center;
        padding: 6px 1px;
        padding-right: 15px;
        border-radius: 8px;

        &.filled {
          i {
            opacity: 1 !important;
            position: relative !important;
            top: unset;

          }
        }

        i {
          color: #4E9280;
          transition: all 1s ease-in-out;
        }

        &:focus-within {
          box-shadow: 0 0 0 1.5px rgb(41, 79, 138) !important;
          border: unset;
          border-radius: 6px;
          color: var(--bs-body-color);
          background-color: var(--bs-body-bg);
          outline: 0;
        }
      }

      input, textarea {
        color: #000 !important;
        font-size: 16px !important;
        font-style: normal !important;
        font-weight: 600 !important;
        line-height: 167.188% !important;
        font-family: "DM Sans", sans-serif;
        border: 0;
        width: 100%;
        padding: 7px 16px;
        background-color: white !important;


        &:focus, &:focus-visible {
          /* shadow-03 */
          border-radius: 6px;
          //border: 1px solid var(--gray-06, #E2E2E2) !important;
          outline: unset;

        }
      }
    }


  }

  .SubmitBtnHolder {
    width: 100%;
    flex-shrink: 1;

    label {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 12px;
      line-height: 12px;
    }

    .PreviousBtn {
      border-radius: 6px;
      border: 1px solid var(--base-primary, #061B3A);
      display: flex;
      padding: 11px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      cursor: pointer;
      rotate: 180deg;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;

      i {
        @media screen and (max-width: 791px) {
          font-size: 12px;
        }
      }

      &:hover {
        background-color: #F8F8F8;
      }
    }

    .btn.NextBtn {
      width: max-content;
      border-radius: 6px;
      display: flex;
      padding: 11px 18px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 1;
      background: #000000;
      color: white;
      cursor: pointer;
      font-size: 14px;
      border: 1px solid black;

      &:hover {
        background-color: white;
        color: black;
      }

      @media screen and (max-width: 791px) {
        font-size: 14px;
        padding-top: 10px;
        padding-bottom: 10px;
      }
      font-style: normal;
      font-weight: 500;
    }
  }

}

</style>
<style>
.KontaktWayMultiselect.error, .tidsPlanMultiselect.error {
  border: 1px solid red;
  border-radius: 5px;
}
</style>
<style lang="scss">
.checkout_summary {
  li.multiselect__element {
    padding-left: 10px;
    padding-right: 10px;
  }

  .multiselect__content {
    color: #000;
  }

  .multiselect__option--selected {
    font-weight: 400;
    color: #000;
  }

  .multiselect__option--highlight {
    background: #f3f3f3 !important;
    color: #000 !important;
    border-radius: 4px;
  }

  .multiselect__placeholder {
    color: #A4A4A4 !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 31px;
    font-family: "DM Sans", sans-serif;
  }

  .multiselect__select {
    min-height: 47px;
    color: #000 !important;
  }

  .multiselect__single {
    line-height: 31px;
    padding-left: 10px;
    color: #000 !important;
    font-weight: 600;
  }

  .multiselect__tags {
    min-height: 54.72px;
  }

  .multiselect__content-wrapper {
    box-shadow: 0 8px 15px 1px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
}

</style>
